// extracted by mini-css-extract-plugin
export var pictureGroup = "index-module--pictureGroup--2kVeM";
export var videoBtn = "index-module--videoBtn--t6JS+";
export var videoIndexMb = "index-module--videoIndexMb--5WDDs";
export var videoPicture = "index-module--videoPicture---q2ER";